import React from 'react';
import {
  Container,
  Heading,
  Section,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import { useParams, useHistory } from 'react-router-dom';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { AddEditParentAdminForm } from 'src/components/enterprise/Parents/Admin/AddParentAdminController/AddEditParentAdminForm/AddEditParentAdminForm';
import { IAddEditParentAdminFormData } from 'src/components/enterprise/Parents/Admin/types';
import { useCreateParentAdmin } from 'src/components/enterprise/Parents/Admin/hooks/useCreateParentAdmin/useCreateParentAdmin';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { useGetParentAccountsRedirectUrl } from 'src/components/enterprise/Parents/Admin/hooks/useGetParentAccountsRedirectUrl/useGetParentAccountsRedirectUrl';

export const AddParentAdminController: React.FC = () => {
  const { corpid: corpId } = useParams<{ corpid: string }>();
  const { push } = useHistory();

  const useFormProps = useForm<IAddEditParentAdminFormData>({
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      internalId: '',
      ssoUniqueIdentifier: '',
      corpSsoIdentifierType: null,
    },
    mode: 'onBlur',
  });

  const { handleSubmit } = useFormProps;

  const { createParentAdmin } = useCreateParentAdmin({ corpId });

  const onSubmit = (formData: IAddEditParentAdminFormData) => {
    createParentAdmin(formData);
  };

  const onCancel = () => {
    const parentOverviewLink = `/corporate/enterprise/parents/${corpId}/admin`;
    push(parentOverviewLink);
  };

  const parentAccountsUrl = useGetParentAccountsRedirectUrl();

  return (
    <Container variant="default">
      <Section inset="sm">
        <PageHeader>
          <Stack y="x-sm">
            <Heading variant="h2">Add parent admin</Heading>
          </Stack>
          <Breadcrumbs
            breadcrumbs={[
              parentAccountsUrl,
              {
                label: 'Parent admins',
                href: `/corporate/enterprise/parents/${corpId}/admin`,
                useRouterLink: true,
              },
            ]}
          />
        </PageHeader>
        <FormProvider {...useFormProps}>
          <AddEditParentAdminForm
            onSubmit={handleSubmit(onSubmit)}
            onCancel={onCancel}
          />
        </FormProvider>
      </Section>
    </Container>
  );
};
